class Panels{
  static init(){
    const panels = document.querySelectorAll('.panel');
    panels.forEach(panel =>{
      panel.querySelectorAll('.btn-close, .dimmer').forEach(el => {
        el.addEventListener('click', ()=>{
          panel.classList.remove('active');
        })
      })
    })
  }
}

export {Panels}